/**
 * Helper utilities for parsing announcement details and tags
 */

export function parseDetailImage(detail) {
  if (!detail) return '';
  const cleanDetail = detail.replace(/&amp;/g, '&');

  if (cleanDetail.includes('####')) {
    const parts = cleanDetail.split('####').filter((p) => p.trim() !== '');
    if (parts.length > 0 && (parts[0].startsWith('http://') || parts[0].startsWith('https://'))) {
      return parts[0].trim();
    }
  } else if (cleanDetail.trim().startsWith('_image1_') && cleanDetail.includes('<div class="text-center">')) {
    const parts = cleanDetail.split('<div class="text-center">');
    return parts[0].replace('_image1_', '').trim();
  }

  const match = cleanDetail.match(/<img[^>]+src=["']([^"']+)["']/i);
  if (match && match[1]) {
    return match[1].trim();
  }
  return '';
}

export function parseDetailContent(detail) {
  if (!detail) return '';
  const cleanDetail = detail.replace(/&amp;/g, '&');

  if (cleanDetail.includes('####')) {
    const parts = cleanDetail.split('####').filter((p) => p.trim() !== '');
    if (parts.length >= 2) {
      const coverImg = (parts[0] && (parts[0].startsWith('http://') || parts[0].startsWith('https://'))) ? parts[0].trim() : '';
      const bodyContent = parts[1];
      if (!bodyContent.includes('<img') && coverImg) {
        return `<div class="text-center mb-15"><img src="${coverImg}" style="max-width: 100%; border-radius: 8px;" /></div>` + bodyContent;
      }
      return bodyContent;
    }
    if (parts.length === 1 && (parts[0].startsWith('http://') || parts[0].startsWith('https://'))) {
      return `<div class="text-center"><img src="${parts[0].trim()}" style="max-width: 100%; border-radius: 8px;" /></div>`;
    }
  } else if (cleanDetail.trim().startsWith('_image1_') && cleanDetail.includes('<div class="text-center">')) {
    const parts = cleanDetail.split('<div class="text-center">');
    return '<div class="text-center">' + parts.slice(1).join('<div class="text-center">');
  }

  return cleanDetail;
}

export function formatTagName(name) {
  if (!name) return '';
  const map = {
    staff: 'Staff',
    student: 'Student',
    students: 'Student',
    faculty: 'Faculty',
    pc_lecturers: 'PC Lecturers',
    lecturer: 'Lecturer',
  };
  return map[name.toLowerCase()] || name.charAt(0).toUpperCase() + name.slice(1);
}
